import {
  Box,
  Button,
  Center,
  Container,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Heading,
  Image,
  Input,
  Link as LinkUi,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import logo from "../img/Welltower-Logo-Pantone.svg";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import ButtonTheme from "./ButtonTheme";
const API_BASE_API = `/api/`;

const NewFooter = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comments: ""
  });

  const postData = (url, data) => {
    // Default options are marked with *
    return fetch(url, {
      body: JSON.stringify(data), // must match 'Content-Type' header
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: 'same-origin', // include, same-origin, *omit
      headers: {
        "content-type": "application/json",
      },
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      redirect: "follow", // *manual, follow, error
      referrer: "no-referrer", // *client, no-referrer
    }).then((response) => response.json());
  };

  /* TODO - Combine with ContactForm2 that just toggles the property/practice fields */
  /* TODO - Probably keep Chakra Modal/styling/layout from this version; keep Formik and validation from ContactForm2 */

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (validateForm()) {
      setFormSubmitting(true);

    postData(`${API_BASE_API}contactForm`, formData)
    .then((data) => {
      setFormSubmitting(false);
      setFormSubmitted(true);
      //        props.closeModal && props.closeModal();
    })
    .catch((error) => {
      console.error(error);
      setFormSubmitting(false);
    });


    }



  }
  const validateForm = () => {
    let valid = true;
        const rEmail =
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-line
    // Really basic 10-digit validation
    const rPhone = /^\D*\d{3}\D*\d{3}\D*\d{4}\D*$/;
    const newErrors = {};

    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "phone",
      "comments"
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        valid = false;
        newErrors[field] = `${field.charAt(0).toUpperCase() +
          field.slice(1).replaceAll('_', ' ')} is required`;
      }
    });


    if (formData.email && !rEmail.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    if (formData.email && !rPhone.test(formData.phone)) {
      newErrors.phone = "Invalid phone number";
    }

    setErrors(newErrors);
    return valid;
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });



}

  return (
    <>
      <Box
        padding="5rem 0"
        bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)"
      >
        <Container maxW={"95%"}>
          {/* <Center padding="1rem 2rem 1rem 2rem">
         <Image src={logo} width={300}  margin={{ md: "unset", base: "0 auto" }} />
        </Center> */}
          <Grid
            //  gridTemplateColumns={{ lg: "repeat(3, 1fr)", md: "repeat(2,1fr)" }}
            templateColumns={["1fr", "2fr 1fr 1fr"]}
            gap={4}
            py={"95px"}
            color={"DarkBlue"}
            textAlign={{ md: "left", base: "center" }}
          >
            <GridItem mt={5} mb={{ md: 0, base: 10 }}>
              <Image
                src={logo}
                width={300}
                margin={{ md: "unset", base: "0 auto" }}
              />
              <Box marginTop={"90"}>
                <Text
                  textAlign={{ md: "left", base: "center" }}
                  color={"DarkBlue"}
                  fontWeight={600}
                >
                  Welltower Inc.
                </Text>
                <Text
                  textAlign={{ md: "left", base: "center" }}
                  color={"DarkBlue"}
                >
                  {" "}
                  4500 Dorr Street, Toledo, OH 43615
                </Text>
                {/* <Text  textAlign={{md: "left", base:  "center"  }}  color={"DarkBlue"}>Toledo, OH 43615</Text> */}
                <Text
                  textAlign={{ md: "left", base: "center" }}
                  color={"DarkBlue"}
                >
                  419.247.2800 phone 877.670.0070 toll free
                </Text>
                {/* <Text  textAlign={{md: "left", base:  "center"  }}  color={"DarkBlue"}> 877.670.0070 toll free</Text> */}
              </Box>
            </GridItem>
            <GridItem mt={5}>
              <List spacing={4}>
                <ListItem>
                  <a href="/">Home</a>
                </ListItem>
                <ListItem>
                  <a href="/property">Properties</a>
                </ListItem>
                <ListItem>
                  <a href="/portfolio">Portfolio</a>
                </ListItem>
                <ListItem>
                  <a href="/perspective">Perspective</a>
                </ListItem>
                <ListItem>
                  <a href="/who-we-are">Who We Are</a>
                </ListItem>
                <ListItem>
                  <a href="/what-we-do">What We Do</a>
                </ListItem>
              </List>
            </GridItem>
            <GridItem mt={5}>
              <List spacing={4}>
                <ListItem>
                  <a
                    href="https://tenant-welltower.securecafe3.com/newtenantportal/content2/login/?companyId=2058"
                    target="_blank"
                  >
                    Tenant Portal
                  </a>
                </ListItem>
                <ListItem>
                  <a
                    href="https://recruiting.ultipro.com/WEL1008WLLT/JobBoard/30969ce4-3b7e-40a6-b86c-34d3616fe0ed/?q=&o=postedDateDesc&w=&wc=&we=&wpst="
                    target="_blank"
                  >
                    Careers
                  </a>
                </ListItem>
                <ListItem>
                  <LinkUi target="_blank" href="https://welltower.com/">
                    WELL (NYSE)
                  </LinkUi>
                </ListItem>
                <ListItem>
                  <LinkUi onClick={onOpen}>Contact</LinkUi>
                </ListItem>
              </List>
            </GridItem>
          </Grid>
          <Divider borderColor={"DarkTeal"} my={6} />
          <Flex
            justifyContent={"space-between"}
            fontSize={"sm"}
            flexDir={{ md: "row", base: "column" }}
            textAlign={{ md: "left", base: "center" }}
            gap={{ md: 0, base: 4 }}
          >
            <Text color={"DarkTeal"} fontSize={"sm"}>
              Welltower, Inc. 2023 All Rights Reserved
            </Text>
            <List
              display={"flex"}
              gap={4}
              color={"DarkTeal"}
              justifyContent={{ md: "unset", base: "center" }}
            >
              <ListItem>
                <LinkUi
                  target="_blank"
                  href="https://welltower.com/terms-of-use/"
                >
                  Terms of Use{" "}
                </LinkUi>
              </ListItem>
              <ListItem>|</ListItem>
              <ListItem>
                <Link to={"/privacy-policy"}>
                  <LinkUi>Privacy Policy</LinkUi>
                </Link>
              </ListItem>
              <ListItem>|</ListItem>
              <ListItem>
                <Link
                  to={(location) => ({
                    ...location,
                    state: { showCookieConsent: true },
                  })}
                >
                  DO NOT SELL/SHARE MY PERSONAL INFO
                </Link>
              </ListItem>
            </List>
          </Flex>
        </Container>
      </Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={"2xl"}
        isCentered
        blockScrollOnMount={false}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        {/* TODO - Combine with ContactForm2 that just toggles the property/practice fields */}
        {/* TODO - Probably keep Chakra Modal/styling/layout from this version; keep Formik and validation from ContactForm2 */}
        {!formSubmitted ? (<form onSubmit={handleSubmit}><ModalContent borderRadius={30} overflow={"hidden"}>
          <ModalHeader
            fontFamily={"Larken"}
            color={"Teal"}
            fontSize={"4xl"}
            fontStyle={"italic"}
            fontWeight={"400"}
          >
            Contact Form
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>

              <Stack
                spacing={4}
                sx={{
                  ".chakra-form__label": {
                    color: "Teal",
                    fontSize: "sm",
                    fontWeight: "400",
                  },
                }}
              >
                <HStack>
                  <FormControl>
                    <FormLabel>First Name</FormLabel>
                    <Input
                    name="first_name"
                    onChange={handleInputChange}
                     />
                      {errors.first_name && (
                               <Text color={"red"} fontSize={"sm"}>
                                 {errors.first_name}
                               </Text>
                              )}
                  </FormControl>
                  <FormControl>
                    <FormLabel>Last Name</FormLabel>
                    <Input
                    name="last_name"
                    onChange={handleInputChange}
                     />
                      {errors.last_name && (
                               <Text color={"red"} fontSize={"sm"}>
                                 {errors.last_name}
                               </Text>
                              )}
                  </FormControl>
                </HStack>
                <HStack>
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input type="email"
                     name="email"
                     onChange={handleInputChange}
                    />
                      {errors.email && (
                                <Text color={"red"} fontSize={"sm"}>
                                {errors.email}
                              </Text>
                              )}
                  </FormControl>
                </HStack>
                <HStack>
                  <FormControl>
                    <FormLabel>Phone</FormLabel>
                    <Input
                     name="phone"
                     onChange={handleInputChange}
                     />

                    {errors.phone && (
                                <Text color={"red"} fontSize={"sm"}>
                                {errors.phone}
                              </Text>
                              )}
                  </FormControl>
                </HStack>
                <HStack>
                  <FormControl>
                    <FormLabel>Message</FormLabel>
                    <Textarea rows={6}
                     name="comments"
                     onChange={handleInputChange}
                    />

                    {errors.comments && (
                                 <Text color={"red"} fontSize={"sm"}>
                                 {errors.comments}
                               </Text>
                              )}
                  </FormControl>
                </HStack>
              </Stack>

          </ModalBody>

          <ModalFooter gap={4}>
            {!formSubmitting && (<><ButtonTheme
              btnText={"Reset"}
              chakraProps={{
                bgColor: "#d2d2d2",
              }}
            />
            <Button
            type="submit"
      fontWeight={"400"}
      h={"48px"}
      w={{ sm: "208px", base: "100%" }}
      borderRadius={"30px"}
      bgColor={"BrightTurquoise"}
      textTransform={"math-auto"}
      border={"1px solid transparent"}
      _hover={{
        border: "1px solid transparent",
        transform: "translateY(-2px)",
        boxShadow: "lg",
        "svg path": {
          fill: "white",
        },
      }}
    >
     Submit
    </Button></>)}
          </ModalFooter>
        </ModalContent></form>) : (
           <ModalContent>
                      <ModalHeader
                      fontFamily={"Larken"}
                      color={"Teal"}
                      fontSize={"4xl"}
                      fontStyle={"italic"}
                      fontWeight={"400"}
                    >
                      Contact Form
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>Form Submitted Successfully
                    </ModalBody> </ModalContent>
                    )}
      </Modal>
    </>
  );
};

export default NewFooter;
